(function () {
  'use strict';

  function initFjReveal() {
    var targets = document.querySelectorAll('[data-fj-reveal], [data-fj-reveal-group]');
    if (!targets.length) return;

    if (!('IntersectionObserver' in window)) {
      targets.forEach(function (el) { el.classList.add('is-visible'); });
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.15, rootMargin: '0px 0px -70px 0px' }
    );

    targets.forEach(function (el) { observer.observe(el); });
  }

  function initFjParallax() {
    var media = document.querySelector('.fj-hero__media img, .fj-hero__media video');
    if (!media || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    var ticking = false;
    function update() {
      var y = window.scrollY || 0;
      var offset = Math.min(y * 0.25, 120);
      media.style.transform = 'scale(1.06) translateY(' + offset + 'px)';
      ticking = false;
    }
    window.addEventListener('scroll', function () {
      if (!ticking) {
        window.requestAnimationFrame(update);
        ticking = true;
      }
    }, { passive: true });
  }

  function init() {
    initFjReveal();
    initFjParallax();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
